// extracted by mini-css-extract-plugin
export default {"wrapper":"ToggleSidebar_wrapper__wAauA","left":"ToggleSidebar_left__nGAZn","right":"ToggleSidebar_right__0viQn","hideSidebar":"ToggleSidebar_hideSidebar__0jTpL"};